/**
 * Helpers for building tappable contact links from a sede config.
 *
 * Phone numbers in the sede config are stored in human format
 * (e.g. "+39 348 438 4139"). We need three derived shapes:
 *   - tel:  href → strip whitespace, keep the leading +
 *   - wa.me href → strip everything except digits (drops the +)
 *   - display  → as-is, but trimmed
 */

export function telHref(phone: string): string {
  return `tel:${phone.replace(/\s+/g, '')}`
}

export function waHref(phone: string, prefilledMessage?: string): string {
  const digitsOnly = phone.replace(/\D/g, '')
  const base = `https://wa.me/${digitsOnly}`
  if (prefilledMessage) {
    return `${base}?text=${encodeURIComponent(prefilledMessage)}`
  }
  return base
}

export function displayPhone(phone: string): string {
  return phone.trim()
}
